import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import React from 'react';

import { getAuthStatus, getRole } from './selectors';
import Footer from '../includes/Footer';
import Header from '../includes/Header';
import DefaultRedirect from '../DefaultRedirect';

import '../../styles/landing/landing.scss';
import arupLogo from 'Images/arup.svg';
import luminaireBlack from 'Images/logo_v3.svg';
import step1 from 'Images/step1.svg';
import step2 from 'Images/step2.svg';
import step3 from 'Images/step3.svg';
import step4 from 'Images/step4.svg';
import { Link } from 'react-router-dom';

class LandingPage extends React.PureComponent {
  render() {
    if (this.props.isAuthenticated) {
      return <DefaultRedirect role={this.props.role} />;
    }
    return (
      <Grid
        spacing={0}
        container
        alignItems="center"
        justify="center"
        spacing={0}
        className="template-landing"
      >
        <Grid
          className="landing-welcome-message"
          container
          justify="center"
          spacing={0}
        >
          <Header />
          <Grid className="landing-content" item xs={10}>
            <Grid item xs={12} md={7}>
              <h1 className="h1-projects t-color-w landing-page-title u-mrg-bot-30 u-mrg-top-30">
                Luminaire Broker connects designers, engineers and architects
                shaping lighting solutions in collaboration with industry:
                matching suppliers to specifications
              </h1>
            </Grid>
            <Grid container>
              <Grid item md={6} xs={12}>
                <p className="t-color-w t-secondary-16 u-mrg-bot-10 font20">
                  Not a member yet?
                </p>
                <Button
                  variant="contained"
                  className="landing-request-to-join t-primary-16 t-weight-b buttonHome"
                  component={Link}
                  to={`/registration`}
                >
                  Suppliers - Send a request to join
                </Button>
                <div id="scrollDownIndicator" className="scrollDownIndicator" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justify="center"
          spacing={0}
          className="landing-middle-block"
        >
          <Grid item md={8} xs={7}>
            <p className="t-secondary-18 u-mrg-bot-40 u-mrg-top-40">
              Luminaire Broker is designed for Electrical Engineers and Lighting
              Designers to communicate with Lighting industry representatives
              and manufacturers, and between themselves. The topic of this
              communication is how to match the demand and the supply of
              luminaires and to broker the lighting specification.
            </p>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justify="center"
          spacing={0}
          className="landing-bottom-block"
        >
          <Grid item md={8} xs={7}>
            <Grid
              container
              alignItems="center"
              justify="center"
              spacing={0}
              className="landing-bottom-logo"
            >
              <img src={luminaireBlack} className="mw100" alt="" />
              <p className="t-secondary-16 landing-bottom-after-logo-text w100 t-align-c">
                Find the best lighting solution for your project in 3 easy steps
              </p>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              alignItems="center"
              justify="center"
              spacing={0}
              className=""
            >
              <Grid item sm={7} xs={12} className="landing-bottom-four-steps">
                <div className="landing-bottom-step">
                  <div className="step-square">
                    <div className="step-label">
                      <div>Step 1 -</div>
                      <div>Create searches</div>
                    </div>
                    <img src={step1} alt="" />
                    <div className="circle-container">
                      <div className="little-circle" />
                    </div>
                  </div>
                </div>
                <div className="landing-bottom-step">
                  <div className="step-square">
                    <div className="step-label">
                      <div>Step 2 -</div>
                      <div>Shortlist favourites</div>
                    </div>
                    <img src={step2} alt="" />
                    <div className="vertical-dashed-line">
                      <div className="double-circle" />
                    </div>
                  </div>
                </div>
                <div className="landing-bottom-step">
                  <div className="step-square">
                    <div className="step-label">
                      <div>Step 3 -</div>
                      <div>Choose best match</div>
                    </div>
                    <img src={step3} alt="" />
                    <div className="vertical-dashed-line">
                      <div className="double-circle" />
                    </div>
                  </div>
                </div>
                <div className="landing-bottom-step">
                  <div className="step-square">
                    <div
                      className="step-label-last
                    "
                    >
                      Luminaire Broker
                    </div>
                    <img src={step4} alt="" />
                    <div className="circle-container">
                      <div className="little-circle" />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid
              container
              alignItems="center"
              justify="center"
              spacing={0}
              className=""
            >
              <Grid item sm={7} xs={12} className="landing-bottom-four-steps">
                <div className="col18">
                  <div className="purple" />
                </div>
                <div className="col34 dotted-line" />
                <div className="col18">
                  <div className="purple" />
                </div>
              </Grid>
            </Grid>
            <Grid
              container
              alignItems="center"
              justify="center"
              spacing={0}
              className=""
            >
              <Grid item md={8} xs={7} className="landing-bottom-four-steps">
                <p className="t-secondary-16 t-align-c u-mrg-top-30 u-mrg-bot-20">
                  Luminaire Broker allows a specifier to search for the most
                  appropriate lighting product for their live projects, and for
                  suppliers to match their products directly to specifiers’
                  requirements. It facilitates the search for luminaires and
                  provides a direct link to broker the optimal product for each
                  specification.
                </p>
                <Button
                  variant="contained"
                  className="landing-bottom-request-to-join t-primary-16 t-weight-b buttonHome"
                  component={Link}
                  to={`/registration`}
                >
                  Suppliers - Send a request to join
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          spacing={0}
          container
          alignItems="center"
          justify="center"
          spacing={0}
          className="landing-footer"
        >
          <Footer />
        </Grid>
      </Grid>
    );
  }
}

export default connect(state => ({
  isAuthenticated: getAuthStatus(state),
  role: getRole(state),
}))(LandingPage);
